import React from "react";
import { SearchResultsPreview } from "./SearchResultsPreview";
import useAccessResultsPreview from "./useAccessResultsPreview";

export const SearchResultsPreviewContainer = ({
	label,
}: {
	label?: string;
}) => {
	const { results, loading, error } = useAccessResultsPreview();

	return (
		<SearchResultsPreview
			results={results}
			loading={loading}
			error={error}
			label={label}
		/>
	);
};
